__turbopack_context__.v({
  "content": "style-module-scss-module__nBQ-Da__content",
  "index": "style-module-scss-module__nBQ-Da__index",
  "itemDescription": "style-module-scss-module__nBQ-Da__itemDescription",
  "itemTitle": "style-module-scss-module__nBQ-Da__itemTitle",
  "listItem": "style-module-scss-module__nBQ-Da__listItem",
  "slide": "style-module-scss-module__nBQ-Da__slide",
  "slideshow": "style-module-scss-module__nBQ-Da__slideshow",
  "title": "style-module-scss-module__nBQ-Da__title",
  "wrapper": "style-module-scss-module__nBQ-Da__wrapper",
});
